import { FacebookModalStateTypes } from '@enums/digital-audience/FacebookModalStateTypes';
import { Action } from '../../types/Action';
import { AdAccountMatching } from '@appTypes/digital-audience/DigitalAudience';

export enum DigitalAudienceAccountsActionsType {
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_OPENED = 'Set digital audience account modal opened',
  SET_DIGITAL_AUDIENCE_ACCOUNT_ISLOADING = 'Set digital audience account is loading',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERTOKEN = 'Set digital audience facebook user token',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERNAME = 'Set digital audience facebook user name',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISLOGGEDIN = 'Set digital audience facebook is logged in',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_CURRENTSTATE = 'Set digital audience facebook current state',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISEVERYTHINGONBOARDED = 'Set digital audience facebook is everything onboarded',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTMATCHINGLIST = 'Set digital audience facebook ad account matching list',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISONBOARDINGSAVEBLOCKED = 'Set digital audience facebook is onboarding save blocked',
  SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTACCEPTEDTERMS = 'Set digital audience facebook ad account accepted terms',
  TOGGLE_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTTERMCHECKED = 'Set digital audience facebook ad account term checked',
  RESET_DIGITAL_AUDIENCE_FACEBOOK_STATE = 'Reset digital audience facebook state'
}

export const setDigitalAudienceAccountModalOpened = (isOpened: boolean): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_OPENED,
  payload: { isOpened: isOpened }
});

export const setDigitalAudienceAccountIsLoading = (isLoading: boolean): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_ISLOADING,
  payload: { isLoading: isLoading }
});

export const setDigitalAudienceFacebookUserToken = (userToken: any): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERTOKEN,
  payload: { userToken: userToken }
});

export const setDigitalAudienceFacebookUserName = (userName: any): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERNAME,
  payload: { userName: userName }
});

export const setDigitalAudienceFacebookIsLoggedIn = (isLoggedIn: boolean): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISLOGGEDIN,
  payload: { isLoggedIn: isLoggedIn }
});

export const setDigitalAudienceFacebookCurrentState= (currentState: FacebookModalStateTypes): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_CURRENTSTATE,
  payload: { currentState: currentState }
});

export const setDigitalAudienceFacebookIsEverythingOnboarded = (isEverythingOnboarded: boolean): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISEVERYTHINGONBOARDED,
  payload: { isEverythingOnboarded: isEverythingOnboarded }
});

export const setDigitalAudienceFacebookAdAccountMatchingList = (adAccountMatchingList: AdAccountMatching[]): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTMATCHINGLIST,
  payload: { adAccountMatchingList: adAccountMatchingList }
});

export const setDigitalAudienceFacebookIsOnboardingSaveBlocked = (isOnboardingSaveBlocked: boolean): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISONBOARDINGSAVEBLOCKED,
  payload: { isOnboardingSaveBlocked: isOnboardingSaveBlocked }
});

export const setDigitalAudienceFacebookAdAccountAcceptedTerms = (acceptedTerms: {key: string, value: boolean}[]): Action => ({
  type: DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTACCEPTEDTERMS,
  payload: { acceptedTerms: acceptedTerms }
});

export const toggleDigitalAudienceFacebookAdAccountTermChecked = (adAccountId: string): Action => ({
  type: DigitalAudienceAccountsActionsType.TOGGLE_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTTERMCHECKED,
  payload: { adAccountId: adAccountId }
});

export const resetDigitalAudienceFacebookState = (): Action =>({
  type: DigitalAudienceAccountsActionsType.RESET_DIGITAL_AUDIENCE_FACEBOOK_STATE,
  payload: { }
});

export type DigitalAudienceAccountsActions = ReturnType<
| typeof setDigitalAudienceAccountModalOpened
| typeof setDigitalAudienceAccountIsLoading
| typeof setDigitalAudienceFacebookUserToken
| typeof setDigitalAudienceFacebookUserName
| typeof setDigitalAudienceFacebookIsLoggedIn
| typeof setDigitalAudienceFacebookCurrentState
| typeof setDigitalAudienceFacebookIsEverythingOnboarded
| typeof setDigitalAudienceFacebookAdAccountMatchingList
| typeof setDigitalAudienceFacebookIsOnboardingSaveBlocked
| typeof setDigitalAudienceFacebookAdAccountAcceptedTerms
| typeof resetDigitalAudienceFacebookState
| typeof toggleDigitalAudienceFacebookAdAccountTermChecked
>;
